// extracted by mini-css-extract-plugin
module.exports = {"mobileView":"TheoryPage_mobileView__3rhbC","imageBox":"TheoryPage_imageBox__37u_T","theoryPageTopContent":"TheoryPage_theoryPageTopContent__3muLj"};